import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        py: 4,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url("https://images.unsplash.com/photo-1465146633011-14f8e0781093?q=80&w=2076&auto=format&fit=crop")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'brightness(0.7)',
          zIndex: 0,
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(46, 125, 50, 0.85) 0%, rgba(76, 175, 80, 0.75) 50%, rgba(129, 199, 132, 0.65) 100%)',
          zIndex: 1,
        },
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          sx={{
            mb: 3,
            color: '#ffffff',
            background: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(10px)',
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.3)',
            }
          }}
        >
          Voltar
        </Button>

        <Paper elevation={24} sx={{ p: 4, borderRadius: 3, background: 'rgba(255, 255, 255, 0.98)', backdropFilter: 'blur(20px)' }}>
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              color: '#2E7D32',
              mb: 3,
            }}
          >
            Política de Privacidade
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </Typography>

          <Box sx={{ '& > *': { mb: 3 } }}>
            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                1. Introdução
              </Typography>
              <Typography variant="body1" paragraph>
                Bem-vindo ao Semente Diária. Esta Política de Privacidade descreve como coletamos,
                usamos, armazenamos e protegemos suas informações pessoais quando você utiliza
                nosso aplicativo de devocionais bíblicos diários.
              </Typography>
              <Typography variant="body1" paragraph>
                Ao utilizar o Semente Diária, você concorda com as práticas descritas nesta política.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                2. Informações que Coletamos
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>2.1. Informações de Conta:</strong>
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Nome completo</li>
                  <li>Endereço de e-mail</li>
                  <li>Foto de perfil (opcional)</li>
                  <li>Senha (armazenada de forma criptografada)</li>
                </ul>
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>2.2. Informações de Uso:</strong>
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Progresso de leitura dos devocionais</li>
                  <li>Vídeos assistidos e percentual de visualização</li>
                  <li>Favoritos marcados</li>
                  <li>Histórico de acesso ao aplicativo</li>
                </ul>
              </Typography>

              <Typography variant="body1" paragraph>
                <strong>2.3. Informações Técnicas:</strong>
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Tipo de dispositivo</li>
                  <li>Sistema operacional</li>
                  <li>Endereço IP</li>
                  <li>Logs de acesso e erros</li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                3. Como Usamos Suas Informações
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                Utilizamos suas informações para:
                <ul>
                  <li>Fornecer e melhorar nossos serviços</li>
                  <li>Personalizar sua experiência com conteúdo devocional</li>
                  <li>Acompanhar seu progresso espiritual</li>
                  <li>Enviar notificações sobre novos devocionais (se autorizado)</li>
                  <li>Comunicar atualizações e novidades do aplicativo</li>
                  <li>Garantir a segurança e prevenir fraudes</li>
                  <li>Cumprir obrigações legais</li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                4. Compartilhamento de Informações
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Não vendemos suas informações pessoais.</strong> Podemos compartilhar suas
                informações apenas nas seguintes situações:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>
                    <strong>Provedores de Serviço:</strong> Com empresas que nos auxiliam na operação
                    do aplicativo (hospedagem, analytics, notificações push)
                  </li>
                  <li>
                    <strong>Requisitos Legais:</strong> Quando exigido por lei ou para proteger
                    nossos direitos
                  </li>
                  <li>
                    <strong>Com seu Consentimento:</strong> Em outras situações, apenas com sua
                    autorização explícita
                  </li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                5. Segurança dos Dados
              </Typography>
              <Typography variant="body1" paragraph>
                Implementamos medidas de segurança técnicas e organizacionais para proteger suas
                informações:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Criptografia de dados em trânsito (HTTPS/SSL)</li>
                  <li>Criptografia de senhas (bcrypt)</li>
                  <li>Autenticação via JWT (JSON Web Tokens)</li>
                  <li>Backups regulares e seguros</li>
                  <li>Monitoramento contínuo de segurança</li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                6. Seus Direitos
              </Typography>
              <Typography variant="body1" paragraph>
                De acordo com a LGPD (Lei Geral de Proteção de Dados), você tem direito a:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>Acessar seus dados pessoais</li>
                  <li>Corrigir dados incompletos ou desatualizados</li>
                  <li>Solicitar a exclusão de seus dados</li>
                  <li>Revogar consentimento a qualquer momento</li>
                  <li>Portabilidade dos seus dados</li>
                  <li>Informações sobre compartilhamento</li>
                </ul>
              </Typography>
              <Typography variant="body1" paragraph>
                Para exercer seus direitos, entre em contato através do e-mail:{' '}
                <strong>privacidade@sementediaria.com.br</strong>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                7. Cookies e Tecnologias Similares
              </Typography>
              <Typography variant="body1" paragraph>
                Utilizamos cookies e tecnologias similares para melhorar sua experiência,
                incluindo:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <ul>
                  <li>
                    <strong>Cookies Essenciais:</strong> Necessários para o funcionamento do
                    aplicativo
                  </li>
                  <li>
                    <strong>Cookies de Preferência:</strong> Lembram suas configurações
                  </li>
                  <li>
                    <strong>Cookies de Analytics:</strong> Ajudam a entender como você usa o app
                  </li>
                </ul>
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                8. Retenção de Dados
              </Typography>
              <Typography variant="body1" paragraph>
                Mantemos suas informações pelo tempo necessário para fornecer nossos serviços e
                cumprir obrigações legais. Dados de contas inativas por mais de 2 anos podem ser
                excluídos, mediante notificação prévia.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                9. Menores de Idade
              </Typography>
              <Typography variant="body1" paragraph>
                Nosso serviço é destinado a pessoas maiores de 13 anos. Para menores de 18 anos,
                recomendamos o acompanhamento de pais ou responsáveis. Não coletamos
                intencionalmente dados de crianças menores de 13 anos.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                10. Alterações nesta Política
              </Typography>
              <Typography variant="body1" paragraph>
                Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você
                sobre mudanças significativas através do aplicativo ou por e-mail. A data da última
                atualização sempre estará indicada no topo desta página.
              </Typography>
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: '#2E7D32' }}>
                11. Contato
              </Typography>
              <Typography variant="body1" paragraph>
                Para dúvidas, sugestões ou solicitações relacionadas a esta Política de
                Privacidade, entre em contato:
              </Typography>
              <Typography variant="body1" component="div" paragraph>
                <strong>E-mail:</strong> privacidade@sementediaria.com.br
                <br />
                <strong>Responsável pela Proteção de Dados:</strong> [Nome do DPO]
              </Typography>
            </Box>
          </Box>

          <Box sx={{ mt: 4, p: 3, bgcolor: '#e8f5e9', borderRadius: 2 }}>
            <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
              Ao utilizar o Semente Diária, você reconhece que leu, compreendeu e concordou com
              esta Política de Privacidade.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
